import { render, staticRenderFns } from "./FieldType24.vue?vue&type=template&id=2f15e9ba&scoped=true"
import script from "./FieldType24.vue?vue&type=script&lang=js"
export * from "./FieldType24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15e9ba",
  null
  
)

export default component.exports